function zoomGallery() {
    const imagesAttributes = document.getElementsByClassName('product-gallery__media');
    let actualImage = null;
    let actualAttribute = '';
    var principalImageGallery = '';
    const containerSecondaryImage = document.getElementsByClassName('product-secondary-image')[0];
    var lens = '';
    let ratio = 3;
    let window_width = null;

    let style_attributes = `--zoom-x: 0%; --zoom-y: 0%; --display-secondary: none; --opacity-secondary: 0`;
    containerSecondaryImage.setAttribute('style', style_attributes);

    const totalVariants = document.getElementById('total_variants');

    widthActual();
    getZoom();

    function getZoom() {
        getActualImage().then((img) => {
            let imgActual = img.getElementsByClassName('rounded')[0];
            let image_src = imgActual.getAttribute('src');
            style_attributes = `${style_attributes}--url-secondary: url(${image_src});`;
            containerSecondaryImage.setAttribute('style', style_attributes);
        });
    };

    if (parseInt(totalVariants.value) == 1) {
        principalImageGallery = document.getElementsByClassName('product-gallery__ar-wrapper')[0];
        lens = document.getElementById('lens');

        zoomPrincipalImageGallery(principalImageGallery);

    } else {
        setTimeout(() => {
            getElementsProductGallery().then((element) => {
                principalImageGallery = element.getElementsByClassName('product-gallery__ar-wrapper')[0];
                zoomPrincipalImageGallery(principalImageGallery);
            })
        }, 100);
    }

    function zoomPrincipalImageGallery(principalImageGallery) {
        principalImageGallery.addEventListener('mouseenter', (event) => {
            getZoom();

            if (window_width > 1150) {
                lens.style.setProperty('--display-lens', 'block');
                lens.style.setProperty('--opacity-lens', '1');
            } else {
                if(lens) {
                    lens.style.setProperty('--display-lens', 'none');
                    lens.style.setProperty('--opacity-lens', '0');
                }
            }
        });

        principalImageGallery.addEventListener('mousemove', (event) => {
            if (window_width > 1150) {
                containerSecondaryImage.style.setProperty('--display-secondary', 'block');
                containerSecondaryImage.style.setProperty('--opacity-secondary', '1');
                containerSecondaryImage.style.setProperty('transition', 'all 50ms linear');
                lens.style.setProperty('--display-lens', 'block');
                lens.style.setProperty('--opacity-lens', '1');

                let pointer = {
                    x: (event.offsetX * 100) / principalImageGallery.offsetWidth,
                    y: (event.offsetY * 100) / principalImageGallery.offsetHeight
                }

                containerSecondaryImage.style.setProperty('--zoom-x', pointer.x + '%');
                containerSecondaryImage.style.setProperty('--zoom-y', pointer.y + '%');

                let pos = getCursor();

                let positionLeft = pos.x - (lens.offsetWidth / 2)
                let positionTop = pos.y - (lens.offsetHeight / 2)

                if (positionLeft < 0) {
                    positionLeft = 0
                }

                if (positionTop < 0) {
                    positionTop = 0
                }

                if (positionLeft > principalImageGallery.width - lens.offsetWidth / 3) {
                    positionLeft = principalImageGallery.width - lens.offsetWidth / 3
                }

                if (positionTop > principalImageGallery.height - lens.offsetHeight / 3) {
                    positionTop = principalImageGallery.height - lens.offsetHeight / 3
                }

                lens.style.left = positionLeft + 'px';
                lens.style.top = positionTop + 'px';

                lens.style.backgroundPosition = "-" + (pos.x * ratio) + 'px -' + (pos.y * ratio) + 'px'
            }
        });

        principalImageGallery.addEventListener('mouseout', () => {
            if (window_width > 1150) {
                containerSecondaryImage.style.setProperty('--display-secondary', 'none');
                containerSecondaryImage.style.setProperty('--opacity-secondary', '0');
                containerSecondaryImage.style.setProperty('transition', 'all 50ms linear');
                lens.style.setProperty('--display-lens', 'none');
                lens.style.setProperty('--opacity-lens', '0');
            }
        });
    }


    function getCursor() {
        let e = window.event
        let bounds = principalImageGallery.getBoundingClientRect();

        let x = e.pageX - bounds.left
        let y = e.pageY - bounds.top
        x = x - window.pageXOffset;
        y = y - window.pageYOffset;

        return { 'x': x, 'y': y }
    }

    function getActualImage() {
        return new Promise((resolve, reject) => {
            for (var i = 0; i < imagesAttributes.length; i++) {
                imagesAttributes[i].classList.add("clase-agregada");

                if (imagesAttributes[i].classList.contains('is-selected')) {
                    actualImage = imagesAttributes[i];
                    resolve(actualImage);
                }
            }
        });
    };

    function widthActual() {
        window_width = window.innerWidth;
    }

    function getElementsProductGallery() {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                let productGalleryElements = document.getElementsByTagName('product-gallery');
                let lensElements = document.getElementsByClassName('lens');
                let arrLens = []

                for (let i = 0; i < lensElements.length; i++) {
                    arrLens.push(lensElements[i]);

                    if (i == 1) {
                        lens = arrLens[1];

                    }
                }
                let style_lens = `--display-lens: none; --opacity-lens: 0`;
                lens.setAttribute('style', style_lens);

                for (let i = 0; i < productGalleryElements.length; i++) {
                    const element = productGalleryElements[i];

                    if (element.classList.contains('starapps')) {
                        resolve(element);
                    }
                }
            }, 650);
        });
    }

    window.addEventListener("DOMContentLoaded", (ev) => {
        if (window_width < 1150) {
            lens.style.setProperty('--display-lens', 'none');
            lens.style.setProperty('--opacity-lens', '0');
        }

        window.addEventListener("resize", (event) => {
            widthActual();

            if (window_width < 1150) {
                lens.style.setProperty('--display-lens', 'none');
                lens.style.setProperty('--opacity-lens', '0');
            }
        });

    });
}


function zoomGalleryMobile() {
    const imagesAttributes = document.getElementsByClassName('product-gallery__media');
    const popup = document.querySelector('.popup-main');
    let thumbnailGallery = [];
    const closeBtn = document.querySelector('.btn-close-main');
    const largePreview = document.querySelector('.image-preview-main');
    const largeImage = document.querySelector('.large-image-main');
    const leftArrowMob = document.querySelector('.left-arrow-zoom-main');
    const rightArrowMob = document.querySelector('.right-arrow-zoom-main');
    const leftArrow = document.querySelector('.left-arrow-main');
    const rightArrow = document.querySelector('.right-arrow-main');
    const minusBtn = document.querySelector('.minus-zoom-main');
    const plusBtn = document.querySelector('.plus-zoom-main');
    const canvasZoom = document.querySelector('.canvasZoom');
    const mediaWrapperZoom = document.getElementsByClassName('product-gallery__zoom');
    var imageGalleryMobile = '';
    const thumbnailImageContainer = document.getElementsByClassName('thumbnails-image-main')[0];
    let imagesGalleryMain = null;
    let bodyTemplate = document.getElementsByTagName('body');
    let actualImage = null;
    let actualAttribute = '';
    let imagesVariants = [];
    var window_width = null;
    let srcImageActual = '';
    let index = 0;
    let scale = 1;
    var counter = 1;
    var zoom = {
        min: 1,
        max: 5,
        value: 1,
        step: 0.05
    };
    let x, y;
    let resetTimeout;
    const buttonLeft = [leftArrowMob, leftArrow];
    const buttonRight = [rightArrowMob, rightArrow];
    widthActual();

    setTimeout(() => {
        getElementsProductGallery().then((element) => {
            imageGalleryMobile = element;

            imageGalleryMobile.addEventListener('click', (event) => {
                if(event.target.type != 'button') {
                    getActualImage().then((img) => {
                        let imgActual = img.getElementsByClassName('rounded')[0];
                        let image_src = imgActual.getAttribute('src');
                        let dataPostion = img.getAttribute('data-position');
    
                        let pos = parseInt(dataPostion);
                        actualAttribute = imgActual.getAttribute('alt');
    
                        largeImage.src = `${image_src}`;
                        popup.classList.toggle('active');
                        getImagesVariants(actualAttribute, pos);
                    });
                }
            });
        })
    }, 500);

    if (window_width < 1150) {
        mediaWrapperZoom[0].addEventListener('click', (event) => {
            event.preventDefault();
            bodyTemplate[0].style.overflow = 'hidden';

            getActualImage().then((img) => {
                let imgActual = img.getElementsByClassName('rounded')[0];
                let image_src = imgActual.getAttribute('src');
                let dataPostion = img.getAttribute('data-position');

                let pos = parseInt(dataPostion);
                actualAttribute = imgActual.getAttribute('alt');

                largeImage.src = `${image_src}`;
                popup.classList.toggle('active');
                getImagesVariants(actualAttribute, pos);
            }).then(() => {
                getThumbnail().then(galleryThumbnail => {
                    for (let x = 0; x < galleryThumbnail.length; x++) {
                        galleryThumbnail[0].classList.add('active');

                        let image = thumbnailGallery[x].getElementsByClassName('rounded')[0].src;
                        const newImage = document.createElement("img");
                        newImage.src = image;
                        newImage.classList.add('img-thumb');

                        if (x == 0) newImage.classList.add('active');

                        thumbnailImageContainer.appendChild(newImage);

                        newImage.addEventListener('click', (event) => {
                            updateImage(x);
                            index = x;

                            activeThumbnail().then(() => {
                                newImage.classList.add('active');

                                watchActiveArrows();
                            });
                        })
                    }
                });
            });
        });
    }

    const getThumbnail = () => {
        return new Promise((resolve, reject) => {
            for (var i = 0; i < imagesAttributes.length; i++) {
                if (imagesAttributes[i].classList.contains('ivariant')) thumbnailGallery.push(imagesAttributes[i]);

                resolve(thumbnailGallery);
            }
        });
    };

    const cleanThumbnail = () => {
        while (thumbnailImageContainer.firstChild) {
            thumbnailImageContainer.removeChild(thumbnailImageContainer.firstChild);
        }
    };

    const activeThumbnail = () => {
        return new Promise((resolve, reject) => {
            let galleryThumbnail = thumbnailImageContainer.getElementsByClassName('img-thumb');

            for (let x = 0; x < galleryThumbnail.length; x++) {
                if (galleryThumbnail[x].classList.contains('active')) {
                    galleryThumbnail[x].classList.remove('active');
                    resolve();
                }
            }
        });
    };

    const swipeThumbnail = (i) => {
        index = i;

        activeThumbnail().then(() => {
            let galleryThumbnail = thumbnailImageContainer.getElementsByClassName('img-thumb');
            galleryThumbnail[i].classList.add('active');
        });
    }

    const getImagesVariants = (variant_name, position) => {
        let imgActual = '';

        for (var i = 0; i < imagesAttributes.length; i++) {
            if (window_width < 1000) {
                let imgActualContainer = imagesAttributes[i];
                imgActual = imgActualContainer.getElementsByClassName('rounded')[0];

            } else {
                imgActual = imagesAttributes[i].getElementsByClassName('rounded')[0];
            }

            if (imgActual.getAttribute('alt') == variant_name) {
                imagesVariants.push(imgActual);
            }
        }
    };

    const updateImage = (i) => {
        largeImage.src = `${imagesVariants[i].src}`;
        index = i;
        resetZoom();
    }

    if (closeBtn) {
        closeBtn.addEventListener('click', () => {

            if (popup.classList.contains('active')) {
                popup.classList.remove('active');
            }

            bodyTemplate[0].style.overflow = '';
            index = 0;
            thumbnailGallery = [];
            cleanThumbnail();
        });
    }


    if (buttonLeft && buttonRight) {
        buttonLeft.map(btn => {
            btn.addEventListener('click', () => {
                activeArrows(event.target.parentElement, 0);

                if (index > 0) {
                    updateImage(index - 1);
                    swipeThumbnail(index);
                }
            });
        });

        buttonRight.map(btn => {
            btn.addEventListener('click', () => {
                activeArrows(event.target.parentElement, 1);
                if (index < imagesVariants.length - 1) {
                    updateImage(index + 1);
                    swipeThumbnail(index);
                }
            });
        });
    }

    if (minusBtn && plusBtn) {
        minusBtn.addEventListener('click', (event) => {
            if (counter > 1) {
                counter = counter - 1;
                largeImage.style.transform = `scale(${counter})`;
            }
        });

        plusBtn.addEventListener('click', (event) => {
            if (counter <= 8) {
                counter = counter + 1;
                largeImage.style.transform = `scale(${counter})`;
                largeImage.style.transformOrigin = '50%' + ' ' + '50%';
            }
        });
    }

    largePreview.addEventListener('wheel', (event) => {
        event.preventDefault();
        zoomWheelPointer(event);
    });

    largePreview.addEventListener('mousemove', e => {
        x = e.clientX - largePreview.offsetLeft;
        y = e.clientY - largePreview.offsetTop;
    });

    largePreview.addEventListener('mouseleave', e => {
        resetZoom();
        counter = 1;
        const zoom = {
            min: 1,
            max: 5,
            value: 1,
            step: 0.05
        };
        x, y;

        largeImage.style.transform = 'scale(1)';
        largeImage.style.transformOrigin = '50%' + ' ' + '50%';
        largeImage.style.transitionDuration = '1s';
    });

    const watchActiveArrows = () => {
        let indexlImagesVariants = imagesVariants.length - 1;
        buttonLeft.map(btn => index == 0 ? btn.disabled = true : btn.disabled = false);
        buttonRight.map(btn => index == indexlImagesVariants ? btn.disabled = true : btn.disabled = false);
    };

    const activeArrows = (btn, dir) => {
        let indexlImagesVariants = imagesVariants.length - 1;
        let newIndex = index + 1;

        if (dir == 1) {
            buttonLeft.map(btn => newIndex != 0 ? btn.disabled = false : btn.disabled = true);
            buttonRight.map(btn => newIndex == indexlImagesVariants ? btn.disabled = true : btn.disabled = false);

        } else {
            buttonLeft.map(btn => index == 1 ? btn.disabled = true : btn.disabled = false);
            buttonRight.map(btn => newIndex <= imagesVariants.length ? btn.disabled = false : btn.disabled = true);
        }
    };

    const zoomWheelPointer = (event) => {
        const elemento = largeImage;
        const factorZoom = 0.1;

        elemento.addEventListener('wheel', (event) => {
            event.preventDefault();

            if (event.deltaY < 0) {
                zoom.value = zoom.value >= zoom.max ? zoom.max : zoom.value + zoom.step;

            } else if (event.deltaY > 0) {
                zoom.value = zoom.value <= zoom.min ? zoom.min : zoom.value - zoom.step;
            }

            largeImage.style.transform = `scale(${zoom.value})`
            var xPerc = (x * 50) / largeImage.width;
            var yPerc = (y * 50) / largeImage.height;
            largeImage.style.transformOrigin = xPerc + '%' + ' ' + yPerc + '%';
        });
    };

    const resetZoom = () => {
        largeImage.style.transform = `scale(1)`;
        largeImage.style.transitionDuration = '1.5s';
    }

    function widthActual() {
        window_width = window.innerWidth;
    }

    function getElementsProductGallery() {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                let productGalleryMediaListElements = document.getElementsByClassName('product-gallery__media-list-wrapper');
                let productGalleryElements = document.getElementsByTagName('product-gallery');

                for (let i = 0; i < productGalleryElements.length; i++) {
                    const element = productGalleryElements[i];

                    if (element.classList.contains('starapps')) {
                        resolve(element);
                    }
                }
            }, 1000);
        });
    }

    const pinchZoom = (imageElement) => {
        let imageElementScale = 1;

        let start = {};

        // Calculate distance between two fingers
        const distance = (event) => {
            return Math.hypot(event.touches[0].pageX - event.touches[1].pageX, event.touches[0].pageY - event.touches[1].pageY);
        };


        imageElement.addEventListener('touchstart', (event) => {
            imageGalleryMobile[0].classList.add('touch');

            if (event.touches.length === 2) {
                event.preventDefault();

                start.x = (event.touches[0].pageX + event.touches[1].pageX) / 2;
                start.y = (event.touches[0].pageY + event.touches[1].pageY) / 2;
                start.distance = distance(event);

            } else if (event.touches.length == 1) {
                if (imageGalleryMobile[0].classList.contains('touch')) {
                    imageGalleryMobile[0].classList.remove('touch');
                }
            }
        });

        imageElement.addEventListener('touchmove', (event) => {
            if (event.touches.length === 2) {
                event.preventDefault();

                let scale;
                if (event.scale) {
                    scale = event.scale;
                } else {
                    const deltaDistance = distance(event);
                    scale = deltaDistance / start.distance;
                }

                imageElementScale = Math.min(Math.max(1, scale), 4);

                const deltaX = (((event.touches[0].pageX + event.touches[1].pageX) / 2) - start.x) * 2;
                const deltaY = (((event.touches[0].pageY + event.touches[1].pageY) / 2) - start.y) * 2;

                const transform = `translate3d(${deltaX}px, ${deltaY}px, 0) scale(${imageElementScale})`;
                imageElement.style.transform = transform;
                imageElement.style.WebkitTransform = transform;
                imageElement.style.zIndex = "9999";
            }
        });

        imageElement.addEventListener('touchend', (event) => {
            if (imageGalleryMobile[0].classList.contains('touch')) {
                imageGalleryMobile[0].classList.remove('touch');
            }

            imageElement.style.transform = "";
            imageElement.style.WebkitTransform = "";
            imageElement.style.zIndex = "";
        });
    }

    const getActualImage = () => {
        return new Promise((resolve, reject) => {
            for (var i = 0; i < imagesAttributes.length; i++) {
                imagesAttributes[i].classList.add("clase-agregada");

                if (imagesAttributes[i].classList.contains('is-selected')) {
                    actualImage = imagesAttributes[i];
                    resolve(actualImage);
                }
            }
        });
    };

    if (window_width <= 1200) {
        var angleScale = {
            angle: 0,
            scale: 1
        }

        interact(largePreview)
            .gesturable({
                listeners: {
                    start(event) {
                        angleScale.angle -= event.angle

                        clearTimeout(resetTimeout)
                        largeImage.classList.remove('reset')
                    },
                    move(event) {
                        var currentAngle = event.angle + angleScale.angle;
                        var currentScale = event.scale * angleScale.scale;
                        largeImage.style.transform = 'scale(' + currentScale + ')';
                        dragMoveListener(event)
                    },
                    end(event) {
                        angleScale.angle = angleScale.angle + event.angle;
                        angleScale.scale = angleScale.scale * event.scale;
                        resetTimeout = setTimeout(reset, 2500);
                    }
                }
            }).draggable({
                autoScroll: true,
                inertia: true,
                modifiers: [
                    interact.modifiers.restrictRect({
                        restriction: 'parent',
                        endOnly: true
                    })
                ],
                listeners: {
                    move: dragMoveListener
                }
            });
    }

    function dragMoveListener(event) {
        var target = event.target;
        var x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
        var y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;
        target.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
        target.setAttribute('data-x', x);
        target.setAttribute('data-y', y);
    }

    function reset() {
        largePreview.removeAttribute('data-y');
        largePreview.removeAttribute('style');
        largeImage.style.transform = 'scale(1)';
        largeImage.style.transitionDuration = '1.5s';


        angleScale = {
            angle: 0,
            scale: 1
        }
    }

    window.dragMoveListener = dragMoveListener;
}

function getVariant() {
    let productCard = document.getElementsByClassName('product-card');
    for (let i = 0; i < productCard.length; i++) {
        let product = productCard[i];
        let productCardImageContainer = product.getElementsByClassName('product-card__figure')[0];
        let imageLink = productCardImageContainer.getElementsByClassName('link-image')[0];

        if(imageLink) {
            let imageLinkHref = imageLink.getAttribute('href');
            let imageAlt = imageLink.getElementsByClassName('product-card__image')[0].alt;
            let productVariantscontainer = product.getElementsByClassName('product-card__aside')[0];
    
            if (productVariantscontainer) {
                let actualVariant = product.getElementsByClassName('sr-only-variant');
    
                for (let x = 0; x < actualVariant.length; x++) {
                    if (actualVariant[x].dataset.variantMedia) {
                        let dataMedia = actualVariant[x].dataset.variantMedia;
                        let dataMediaJson = JSON.parse(dataMedia);
                        let includesAlt = dataMedia.includes(imageAlt);
    
                        if (imageAlt == dataMediaJson.alt) {
                            let variantID = actualVariant[x].dataset.variantId;
                            imageLink.href = `${imageLinkHref}?variant=${variantID}`;
                            actualVariant[x].checked = true;
                        }
                    }
                }
            }
        }
    }
};


function getProductAvailability(idvariant, newVariant, newContent) {
    getBlockItems().then((blocks) => {
        if (newVariant && newVariant.available) {            
            if(blocks.quantity.classList.contains('out_of_stock')) {
                blocks.quantity.style.display = 'inline-block';
            };

            if (blocks.buyNow) blocks.buyNow.style.display = 'block';

            if(blocks.buyButtons) {
                if (blocks.buyButtons.classList.contains('out_of_stock')) blocks.buyButtons.classList.remove('out_of_stock');
                blocks.buyButtons.classList.add('in_stock');
            }

        } else {
            if (blocks.quantity) {
                if(blocks.quantity.classList.contains('in_stock')) {
                    blocks.quantity.style.display = 'none';
                };

            }

            if (blocks.buyNow) blocks.buyNow.style.display = 'none';
            
            if(blocks.buyButtons) {
                if(blocks.buyButtons.classList.contains('in_stock'))  blocks.buyButtons.classList.remove('in_stock');
                blocks.buyButtons.classList.add('out_of_stock');
            }
        }
    });
}

function getBlockItems() {
    return new Promise((resolve, reject) => {
        const checkElement = () => {
            let blockItemQuantity = document.getElementById('product-info__block-item-quantity_selector');
            let blockItemBuyNow = document.querySelector('div[data-block-type="buy-it-now-button"]');
            let blockItemBuyButtons = document.querySelector('div[data-block-type="buy-buttons"]');

            if (blockItemQuantity) {
                resolve({
                    quantity: blockItemQuantity,
                    buyNow: blockItemBuyNow,
                    buyButtons: blockItemBuyButtons
                });
            } else {
                setTimeout(checkElement, 1500);
            }
        };

        checkElement();
    });
}

export { zoomGallery, zoomGalleryMobile, getVariant, getProductAvailability };